import styled from "styled-components";
import {
  AiFillLinkedin,
  AiFillYoutube,
  AiOutlineInstagram,
} from "react-icons/ai";
import { FaFacebookF } from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterComponent>
      <Nav>
        <LinkNav href="https://bezla.com/capabilities-2" label="Capabilities" />
        <LinkNav href="https://bezla.com/products" label="Products" />
        <LinkNav href="https://bezla.com/insights" label="Insights" />
        <LinkNav href="https://careers.bezla.com/jobs/Careers" label="Careers" />
        <LinkNav href="https://bezla.com/about" label="About" />
        <LinkNav href="https://bezla.com/team" label="Team" />
        <LinkNav href="https://training.bezla.com/login" label="Sign In" />
        <LinkNav href="https://rate.bezla.com/" label="Rate.Bezla.com" />
        <LinkNav href="https://budget.bezla.com/" label="Budget.Bezla.com" />
        <LinkNav href="https://support.bezla.com/portal/en/signin" label="Support.Bezla.com" />
        <LinkNav href="https://swot.bezla.com/" label="Swot.Bezla.com" />
        <LinkNav href="https://training.bezla.com/" label="Hub.Bezla.com" />
        <LinkNav href="https://bezla.com/contact" label="Contact" />
      </Nav>
      <InfoSection>
        <Socials>
          <a href="https://www.facebook.com/BezlaLLC" target="_blank" rel="noreferrer"><div><FaFacebookF/></div></a>
          <a href="https://www.instagram.com/bezlallc/" target="_blank" rel="noreferrer"><AiOutlineInstagram/></a>
          <a href="https://www.linkedin.com/company/bezla" target="_blank" rel="noreferrer"><AiFillLinkedin/></a>
          <a href="https://www.youtube.com/channel/UC5c-NLCogs8r0u8jv49RxJg?view_as=subscriber" target="_blank" rel="noreferrer"><AiFillYoutube/></a>
        </Socials>
        <span>Bezla.com LLC</span>
        <span>1800 JFK Blvd Suite 300 PMB 91649 Philadelphia, PA 19103</span>
        <a href="https://bezla.com/tel:+18889998086">+1-888-999-8086</a>
      </InfoSection>
      <Rights>
        <span>All Rights Reserved. BEZLA BEZLA.COM LLC is a registered trademark. The United States Patent and Trademark Office <strong>Registration Number 6618757</strong>.</span>
        <span>© 2018-{currentYear} Bezla.com LLC</span>
      </Rights>
      <PrivacyPolicy>
        <a href="https://bezla.com/privacy-policy">Privacy Policy</a>
        <span>© 2018-{currentYear} Bezla.com LLC</span>
      </PrivacyPolicy>
    </FooterComponent>
  );
}

const FooterComponent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  width: 100%;
  padding: 8rem 0rem 2rem 0rem;
  font-family: "Noto Sans", sans-serif;
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  max-width: 1100px;

  @media (max-width: 1500px) {
    padding: 0;
  }

  @media (max-width: 1250px) {
    padding: 0;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    text-align: center;
  }
`;

const LinkNav = ({ selected, label, href }) => {
  return (
    <LinkComponent
      selected={selected}
      style={{ letterSpacing: ".071em", fontSize: "23px" }}
      href={href}
    >
      {label}
    </LinkComponent>
  );
};

const LinkComponent = styled.a`
  padding: 0.5rem;
  letter-spacing: 0.071em;
  color: black;
  font-weight: ${(props) => (props.selected ? "700" : "400")};
  text-decoration: none;
  white-space: nowrap;
  font-family: "Noto Sans", sans-serif;
  letter-spacing: 0.063em;
  line-height: 1.5rem;

  &:hover {
    text-decoration: none;
  }

  @media (max-width: 900px) {
    margin-right: 0;
    font-size: 20px;
    letter-spacing: 0.063em;
  }
  @media (min-width: 1536px) {
    font-size: 23px;
  }
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;
  font-size: 23px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  gap: 1rem;
  margin: 3rem 2rem 2rem 2rem;

  & > span:first-of-type {
    font-weight: 700;
  }

  & > a {
    text-decoration: none;
    color: black;
  }

  @media (max-width: 900px) {
    gap: 1rem;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
`;

const Socials = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  & > a {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    background-color: black;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 0.5rem;
    position: relative;
  }

  & > a > div {
    position: absolute;
    margin-bottom: -5px;
    right: 2px;
  }

  @media (max-width: 900px) {
    margin-bottom: 0.5rem;
  }
`;

const Rights = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: black;
  font-size: 20px;
  line-height: 1.5;
  max-width: 1250px;
  
  & > span:first-of-type {
    word-wrap: break-word;
    margin-right: 25rem;
    text-align: left;
  }

  & > span:last-of-type {
    flex-shrink: 0;
    text-align: right;
  }

  @media (max-width: 1500px) {
    margin: 0.5rem 10rem;
  }

  @media (max-width: 1250px) {
    margin: 0.5rem 5rem;

    & > span:first-of-type {
      margin-right: 10rem;
    }
  }

  @media (max-width: 900px) {
    margin-right: 2rem;
    margin-left: 2rem;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0rem;

    & > span:first-of-type {
      text-align: center;
      margin-right: 0;
    }
    
    & > span:last-of-type {
      display: none;
    }
  }
`;

const PrivacyPolicy = styled.div`
  display: flex;
  justify-content: start;
  width: stretch;
  max-width: 1250px;
  margin: 2rem 10rem 0rem 10rem;

  & > a {
    color: black;
    font-size: 18px;
  }

  & span {
    display: none;
  }

  @media (max-width: 900px) {
    padding: 0rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & span {
      display: block;
      color: black;
      font-size: 1.125rem;
      line-height: 1.5;
      margin-top: 0.5rem;
    }
  }

  @media (max-width: 1250px) {
    margin-left: 5rem;
  }
`;